import { render, staticRenderFns } from "./message.vue?vue&type=template&id=00f9e861&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=00f9e861&prod&lang=css"
import style1 from "./message.vue?vue&type=style&index=1&id=00f9e861&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f9e861",
  null
  
)

export default component.exports